
  let loadableApi = window.__VITE_REACT_LOADABLE__
  export async function promiseAllModules() {
    if (loadableApi) {
      return loadableApi.promiseAllModules()
    }

    // no module loading api loaded
    return {}
  }
  // stubbed for clientside
  export function getImportChunkMap() {
    return undefined
  }
  